import React from 'react';
interface MetricStatProps {
  label: string;
  value: string;
  detail?: string;
  tone?: 'default' | 'warn' | 'critical';
  emphasis?: boolean;
}
export function MetricStat({
  label,
  value,
  detail,
  tone = 'default',
  emphasis = false
}: MetricStatProps) {
  const valueColor = tone === 'critical' ? 'text-critical-ink' : tone === 'warn' ? 'text-warn-ink' : 'text-ink';
  return <div className="px-5 py-4" data-id="element-55" data-mp="2ktlq5h1ehdqs">
      <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-ink-soft" data-id="element-56" data-mp="2kumznh2rps6e">
        {label}
      </p>
      <p className={`mt-2 font-mono font-medium leading-none ${valueColor} ${emphasis ? 'text-[2rem]' : 'text-[1.5rem]'}`} data-id="element-57" data-mp="2gtbje25sajav">
        {value}
      </p>
      {detail && <p className="mt-2 text-xs text-ink-muted" data-id="element-58" data-mp="2ptzxsxz3aloa">{detail}</p>}
    </div>;
}